import React from 'react';
import ReactDOM from 'react-dom';
import AuthForm from '../Component/AuthForm.jsx';

ReactDOM.render(<AuthForm/>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/js/Bootstrap/auth.js